import React from 'react';
import { Container } from './styles';

import smileImage from '~/assets/tv/change-your-smile/TV8.png';

interface IChangeYourSmile8Props {
  show: boolean;
  startAnim: boolean;
}

const ChangeYourSmile8: React.FC<IChangeYourSmile8Props> = ({
  show,
  startAnim,
}) => {
  return (
    <Container show={show} startAnim={startAnim}>
      <img className="bg" src={smileImage} alt="chega de esconder o Sorriso" />
    </Container>
  );
};

export default ChangeYourSmile8;
